module.exports = __webpack_public_path__ + "static/clima-02-63ee99e268b6f6dba0c480cb824bcddf.jpg";